export default "__VITE_ASSET__BWYo6U$E__"